import type { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import {
  default as MuiMenu,
  type MenuProps as MuiMenuProps,
} from '@mui/material/Menu';
import MenuList from '@mui/material/MenuList';
import MenuItem from './MenuItem';
import BaseMenuItem from './BaseMenuItem';
import MenuDivider from './MenuDivider';
import { classes, styles } from './utils';

export { MenuItem, BaseMenuItem, MenuDivider };

export interface MenuProps extends PropsWithChildren {
  autoFocus?: boolean;
  open: boolean;
  style?: MuiMenuProps['sx'];
  className?: string;
  anchorOrigin?: MuiMenuProps['anchorOrigin'];
  anchorTo: HTMLElement | null;
  listClassName?: string;
  transformOrigin?: MuiMenuProps['transformOrigin'];
  onClose: () => void;
}

export default function Menu({
  anchorOrigin = { horizontal: 'right', vertical: 'bottom' },
  transformOrigin = { horizontal: 'right', vertical: 'top' },
  className,
  listClassName,
  style = {},
  ...props
}: MenuProps) {
  if (!props.anchorTo) return null;
  return (
    <MuiMenu
      autoFocus={props.autoFocus}
      open={props.open}
      sx={{ ...styles.menu, ...style }}
      anchorEl={props.anchorTo}
      anchorOrigin={anchorOrigin}
      slotProps={{ paper: { className: twMerge(classes.paper, className) } }}
      transformOrigin={transformOrigin}
      onClose={props.onClose}>
      <MenuList className={listClassName}>{props.children}</MenuList>
    </MuiMenu>
  );
}
